module.exports = __webpack_public_path__ + "img/38a262c58fd88f0f6f7a979d752f1f87.png";